import { Component, OnInit } from '@angular/core';
import { Enums } from 'src/app/_models/generatedEnums';
import { ConferenceWithCertificateViewModel, ParticipationModality } from 'src/app/_models/generatedModels';
import { CEUService } from 'src/app/_services/generatedServices';
import { ToasterService } from 'src/app/_services/toaster.service';

@Component({
  selector: 'bxl-conference-certificates',
  templateUrl: 'conference-certificates.component.html',
})
export class ConferenceCertificatesComponent implements OnInit {
  initialized = false;
  conferences: ConferenceWithCertificateViewModel[];

  constructor(private ceuService: CEUService, private toaster: ToasterService) {}

  ngOnInit(): void {
    this.ceuService.getConferencesWithCertificates().subscribe((result) => {
      this.conferences = result;
      this.initialized = true;
    });
  }

  viewCertificates() {
    this.toaster.messageDialog('The conference host has not processed these certificates yet. Please check back later.', 'Processing...', 'OK').subscribe();
  }
}
